<template>
    <div class="list-item" :class="{disabled, 'no-spacing': noSpacing, 'sub-menu': withSubmenu}">
        <div class="list-item-content">
            <label v-if="label">
                {{ label }}
                <i v-if="withSubmenu" class="icon angle-right" />
            </label>
            <slot>
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class ListItem extends Vue {
        @Prop({type: String}) public label?: string;
        @Prop({type: Boolean}) public disabled!: boolean;
        @Prop({type: Boolean}) public noSpacing!: boolean;
        @Prop({type: Boolean}) public withSubmenu!: boolean;
    }
</script>

<style lang="scss" scoped>
    div.list-item {
        background: var(--controls-background);
        color: var(--theme-text-color);

        &, label {
            cursor: pointer;
        }

        &:not(.no-spacing) {
            .list-item-content {
                padding: .5rem;
                display: block;
            }
        }

        &.disabled {
            cursor: not-allowed;
            opacity: .6;

            .list-item-content {
                pointer-events: none;
            }
        }

        &.sub-menu {
            .icon {
                vertical-align: -2px;
                background: var(--control-chevron-color);
            }
        }

        + div.list-item {
            border-top: 1px solid var(--list-border-color);
        }

        &:hover {
            background: var(--list-hover-color);
        }
    }
</style>
